// extracted by mini-css-extract-plugin
module.exports = {"spiner":"spiner_spiner__hKNcy"};